
import React from 'react';
import { Image, Upload, Plus } from 'lucide-react';

const Gallery: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Galeria de Fotos</h1>
          <p className="text-gray-500">Gerencie as fotos dos álbuns e destaques do site.</p>
        </div>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 hover:bg-blue-700">
          <Upload size={18} /> Upload de Fotos
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-purple-50 rounded-full flex items-center justify-center mb-4">
          <Image size={32} className="text-purple-500" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">Sua galeria está vazia</h3>
        <p className="text-gray-500 max-w-sm mx-auto mb-6">
          Adicione fotos das pescarias, instalações e troféus para atrair mais clientes.
        </p>
        <button className="text-blue-600 font-medium hover:underline">
          Criar primeiro álbum
        </button>
      </div>
    </div>
  );
};

export default Gallery;
